
import { http } from '@utils/interceptor'
import { Module } from 'vuex'
import { Toast } from 'vant'

const api = {
    choiceCMSApi: 'https://cms.cekid.com/publish/890/promotion_chose_config.json',
    choiceListApi: '//soperationapi.czj100.com/soperation-api/citySite/queryCustomList.do',
    panicBuyCMSApi: 'https://cms.cekid.com/publish/890/promotion_panicbuy_config.json',
    panicBuyListApi: '//soperationapi.czj100.com/soperation-api/citySite/queryPromotionList.do'
}

export interface BaseResponse<T> {
    code: string
    data: T
    msg: string
}

interface PanicBuyParams {
    cityId: string | number
    spuId: string | number | null
}
interface ChoiceParams {
    spuId: string | number | null
}
export interface PanicBuyResponse {
    group: any[] | null
    seckill: any[] | null
    top: any | null
    s:number | null
}
export interface PromotionCMSResponse {
    title: string
    imgUrl: string
    shareImg: string
    shareDes: string
}
export async function getPanicBuyCMS(): Promise<PromotionCMSResponse> {
    const response = await http.get(api.panicBuyCMSApi)
    if (response && response.code == '0') {
        return response.data
    } else {
        return Promise.reject(response.message)
    }
}
export async function getChoiceCMS(): Promise<PromotionCMSResponse> {
    const response = await http.get(api.choiceCMSApi)
    if (response && response.code == '0') {
        return response.data
    } else {
        return Promise.reject(response.message)
    }
}

export async function getPanicBuyList(req: PanicBuyParams): Promise<PanicBuyResponse> {
    const response: ResponseCode = await http.get(api.panicBuyListApi, { params: req })
    if (response && response.code == '1') {
        return response.data
    } else {
        Toast(response.msg)
        return Promise.reject(response.msg)
    }
}

export async function getChoiceList(req: ChoiceParams): Promise<any[]> {
    const response: ResponseCode = await http.get(api.choiceListApi, { params: req })
    if (response && response.code == '1') {
        return response.data
    } else {
        Toast(response.msg)
        return Promise.reject(response.msg)
    }
}

interface PanicBuyState {
    config: PromotionCMSResponse | null
    panicbuys: PanicBuyResponse | null
}
export const PANIC_BUY_STORE: Module<PanicBuyState, any> = {
    namespaced: true,
    state: () => ({
        config: null,
        panicbuys: null
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
    }
}

interface ChoiceState {
    config: PromotionCMSResponse | null
    choices: any[] | null
}
export const CHOICE_STORE: Module<ChoiceState, any> = {
    namespaced: true,
    state: () => ({
        config: null,
        choices: null
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
    }
}